module.exports = __webpack_public_path__ + "0d90d3f1e86dfb4a91b5a804655c2aae.svg";